import { render, staticRenderFns } from "./LanguageManager.vue?vue&type=template&id=144ebde3&"
import script from "./LanguageManager.vue?vue&type=script&lang=ts&"
export * from "./LanguageManager.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
